/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2020. All Rights Reserved.
 #*
 #*===================================================================
 */
import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appModalScroll]',
})
export class ModalScrollDirective {
  private element;
  constructor(el: ElementRef) {
    this.element = el;
  }

  ngAfterViewInit() {
    let scrollEl;
    for (const child of this.element.nativeElement.children) {
      if (child.className.includes('modal-content-container')) {
        scrollEl = child;
        break;
      }
    }
    if (scrollEl?.scrollHeight > scrollEl?.clientHeight) {
      scrollEl.classList.add('scrolling');
    } else {
      const scrollElements = this.element.nativeElement.querySelectorAll('.modal-content-container');
      for (const el of scrollElements) {
        if (el.scrollHeight > el.clientHeight) {
          el.classList.add('scrolling');
        }
      }
    }
  }
}
